import { Flag } from 'lucide-react';
import { TENSION_LEVELS } from './tensionMeta';

export const TensionPill = ({ level, testid }) => {
  const m = TENSION_LEVELS[level];
  if (!m) return null;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide whitespace-nowrap ${m.pill}`}>
      <Flag className="w-3 h-3" />{m.label}
    </span>
  );
};
